/**
 * Ngày tạo: 08/06/2021
 * Mô tả: Tìm lỗi sai trong câu. In đậm từ sai sẵn, HS cần click vào từ sai.
 */

import { message } from 'antd';
import React from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import QuestionHeader from '../QuestionHeader';

const Underlined = ({ data, userData, onSubmit, questionIndex = 0 }) => {
  const [selectedAnswer, setSelectedAnswer] = React.useState(null);

  React.useEffect(() => {
    if (userData) {
      setSelectedAnswer(userData?.answer);
    }
  }, [userData]);

  const handleSubmit = () => {
    const result = data.answers.find((x) => x.answer === selectedAnswer).isCorrect;
    const answers = selectedAnswer;
    if (onSubmit && typeof onSubmit === 'function') onSubmit({ answers, result });
  };

  const renderQuestion = () => {
    const words = data.question.split(/(#)/);
    let idAnswer = 0;
    return (
      <div className='answers'>
        <span>
          {words.map((word, i) => {
            if (word !== '#') return <React.Fragment key={i}>{word}</React.Fragment>;

            const Answer = data.answers[idAnswer];
            idAnswer++;
            console.log(selectedAnswer);
            return (
              <span
                key={i}
                onClick={(e) => {
                  setSelectedAnswer(e.target.innerText);
                }}
                style={{
                  cursor: 'pointer',
                  fontWeight: 600,
                  paddingBottom: 3,
                  borderBottom: '2px solid #adb5bd',
                  color: Answer.answer === selectedAnswer ? '#2dce89' : null,
                }}
              >
                {Answer.answer}
              </span>
            );
          })}
        </span>
      </div>
    );
  };

  //
  return (
    <Card>
      <CardHeader>
        <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='Underlined' />
      </CardHeader>
      <CardBody style={{ minHeight: 300 }}>
        <div className='questionText'>{renderQuestion()}</div>
      </CardBody>
      <CardFooter>
        <Button color='primary' onClick={handleSubmit}>
          Submit <i className='fas fa-arrow-right ml-3'></i>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default Underlined;
